import firebase from "firebase/app";
import "firebase/firestore";

/**
 * R-Property, the landlord/property-manager dashboard the app now reads listings from
 * (Database/rentalManagerDB.js in the app repo). The website previously read a
 * different, retired project (findrental-30230) — this connection replaces that so the
 * website shows the same live listings as the app.
 *
 *   Users/{managerId}                       name, company, phone, email, county, constituency
 *   Users/{managerId}/properties/{id}       name, address, units, type, rentAmount
 *
 * Only those two levels are ever read — tenants, payments, leases are the manager's
 * private business data.
 */
const firebaseConfig = {
  apiKey: "AIzaSyCd_BsPt7009SjeVlyKGDi3GqJGtqnZvXk",
  authDomain: "rentalmanagementsystem-1ad2b.firebaseapp.com",
  projectId: "rentalmanagementsystem-1ad2b",
  storageBucket: "rentalmanagementsystem-1ad2b.firebasestorage.app",
  messagingSenderId: "522161036039",
  appId: "1:522161036039:web:9aacb28b49a13b41cec3a2",
  measurementId: "G-7VL6BQT43Y",
};

const rentalManagerApp = firebase.initializeApp(firebaseConfig, "rentalManagerWeb");

export const dbm = rentalManagerApp.firestore();
